<template>
  <el-col :span="widgetConfig.span">
    <el-row :style="{'margin-bottom': widgetConfig.supportBottom === 1 ? '20px' : undefined}">
      <el-col :span="24" style="margin-bottom: 10px;" v-if="formType !== SysOnlineFormType.QUERY && formType !== SysOnlineFormType.WORK_ORDER">
        <el-row type="flex" justify="space-between">
          <div class="table-title" :style="{'border-left': '3px solid ' + widgetConfig.titleColor}">
            {{widgetConfig.showName}}
          </div>
          <div>
            <el-button :size="defaultFormItemSize"
              v-for="operation in getTableOperation(false)" :key="operation.id"
              :plain="operation.plain"
              :type="operation.btnType"
              @click.stop="onOperationClick(operation)"
            >
              {{operation.name}}
            </el-button>
          </div>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-table  :size="defaultFormItemSize" header-cell-class-name="table-header-gray" ref="tableImpl"
          :style="{height: (widgetConfig.tableInfo.height != null && widgetConfig.tableInfo.height !== '') ? widgetConfig.tableInfo.height + 'px' : undefined}"
          :height="(widgetConfig.tableInfo.height != null && widgetConfig.tableInfo.height !== '') ? widgetConfig.tableInfo.height + 'px' : undefined"
          :data="tableWidget.dataList" :row-key="primaryColumnName"
          @sort-change="tableWidget.onSortChange" @selection-change="onTableSelectionChange">
          <el-table-column v-if="hasBatchDelete" header-align="center" align="center" type="selection" width="55px" />
          <el-table-column label="序号" header-align="center" align="center" type="index" width="100px" :index="tableWidget.getTableIndex" />
          <template v-for="(tableColumn,order) in widgetConfig.tableColumnList">
            <!-- Boolean类型的字段，使用el-tag去显示 -->
            <el-table-column v-if="(tableColumn.column || {}).objectFieldType === 'Boolean'" :key="tableColumn.dataFieldName"
              :label="tableColumn.showName" :width="tableColumn.columnWidth + 'px'"
              :prop="tableColumn.column.columnName"
              :sortable="tableColumn.sortable ? 'custom' : false"
            >
              <template slot-scope="scope">
                <el-tag :size="defaultFormItemSize" :type="scope.row[tableColumn.dataFieldName] ? 'success' : 'danger'">
                  {{scope.row[tableColumn.dataFieldName] ? '是' : '否'}}
                </el-tag>
              </template>
            </el-table-column>
            <!-- 普通非字典字段 -->
            <template v-else-if="(tableColumn.column || {}).dictInfo == null">
              <el-table-column  :label="tableColumn.showName"
                v-if="tableColumn.column &&
                  (tableColumn.column.fieldKind === SysOnlineFieldKind.UPLOAD ||
                  tableColumn.column.fieldKind === SysOnlineFieldKind.UPLOAD_IMAGE)"
                :key="(tableColumn.column || {}).objectFieldName"
                :width="tableColumn.columnWidth + 'px'"
              >
                <template slot-scope="scope">
                  <template v-if="tableColumn.column.fieldKind === SysOnlineFieldKind.UPLOAD_IMAGE">
                    <el-image
                      v-for="item in parseTableUploadData(tableColumn, scope.row)"
                      :preview-src-list="getTablePictureList(tableColumn, scope.row)"
                      class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
                      <div slot="error" class="table-cell-image">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </template>
                  <template v-else>
                    <a v-for="item in parseTableUploadData(tableColumn, scope.row)"
                      :key="item.url" href="javascript:void(0);" @click="downloadFile(item.url, item.name)">
                      {{item.name}}
                    </a>
                  </template>
                </template>
              </el-table-column>
              <el-table-column  :show-overflow-tooltip='true' v-else :key="(tableColumn.column || {}).objectFieldName"
                :label="tableColumn.showName" :prop="tableColumn.dataFieldName"
                :width="tableColumn.columnWidth + 'px'"
                :sortable="tableColumn.sortable ? 'custom' : false"
              >
                <template slot-scope="{row, column, $index}">
                      <el-date-picker
                      v-if="flag && tableColumn.column.columnType ==='datetime'"
                        v-model="tableWidget.dataList[$index][column['property']]"
                        type="date"
                        placeholder="选择日期">
                      </el-date-picker>
                  <el-input v-else-if="flag " v-model="tableWidget.dataList[$index][column['property']]" :type="filterType(tableColumn.column.columnType)" :placeholder='`请输入${column.label}`'></el-input>
                  <span v-else-if="column['property'] === 'masterTable__seal'" >{{ tableWidget.dataList[$index][column['property']] == null ? '' : tableWidget.dataList[$index][column['property']] == 1 ? '是' : '否' }}</span>
                  <span v-else >{{ tableWidget.dataList[$index][column['property']] }}{{column['property'] === 'masterTable__seal'}}</span>
                </template>
              </el-table-column>
            </template>
            <!-- 字典字段 -->
            <el-table-column v-else :key="(tableColumn.column || {}).objectFieldName"
              :label="tableColumn.showName" :width="tableColumn.columnWidth + 'px'"
              :prop="tableColumn.column.columnName"
              :sortable="tableColumn.sortable ? 'custom' : false"
            >
              <template slot-scope="{row, column, $index}">
                  <el-select  v-if="flag" v-model="tableWidget.dataList[$index][column['property']]" :placeholder='`请选择${column.label}`'>
                    <el-option
                      v-for="item in getDict(tableColumn)"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <span v-else >{{ getDictValue(tableColumn,row) }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column v-if="formType === SysOnlineFormType.WORK_ORDER" label="当前任务"  width="250px" prop="runtimeTaskInfo.taskName" />
          <el-table-column v-if="formType === SysOnlineFormType.WORK_ORDER" label="流程创建时间" width="180px" prop="createTime" />
          <!-- <el-table-column v-if="formType === SysOnlineFormType.WORK_ORDER" label="流程状态" width="100px" prop="flowStatus" /> -->
          <el-table-column v-if="formType === SysOnlineFormType.WORK_ORDER" label="流程状态" width="100px" prop="flowStatus">
            <template slot-scope="scope">
               <span :style="{'color':color[scope.row.flowStatus]}">{{scope.row.flowStatus}}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="getTableOperation(true).length > 0 || formType === SysOnlineFormType.WORK_ORDER"
            label="操作" :width="(widgetConfig.tableInfo.optionColumnWidth || 150) + 'px'" fixed="right"
          >
            <template slot-scope="scope">
              <el-button v-for="operation in getTableOperation(true)" :key="operation.id"
                :class="operation.btnClass"
                type="text" :size="defaultFormItemSize"
                @click.stop="onOperationClick(operation, scope.row)"
              >
                {{ $route.query.formId === '1639182007915253760' ? '详情' : operation.name}}
              </el-button>
              <el-button type="text" :size="defaultFormItemSize"
                v-if="formType === SysOnlineFormType.WORK_ORDER &&( (scope.row.initTaskInfo || {}).taskKey !== (scope.row.runtimeTaskInfo || {}).taskKey|| (scope.row.runtimeTaskInfo || {}).taskKey===undefined)"
                @click.stop="onViewWorkOrder(scope.row)">
                详情
              </el-button>
              <el-button type="text" :size="defaultFormItemSize"
                v-if="formType === SysOnlineFormType.WORK_ORDER && (scope.row.initTaskInfo || {}).taskKey === (scope.row.runtimeTaskInfo || {}).taskKey&&(scope.row.runtimeTaskInfo || {}).taskKey!=undefined"
                @click.stop="onHandlerWorkOrder(scope.row)">
                办理
              </el-button>
              <el-button type="text" :size="defaultFormItemSize"
              v-if="formType === SysOnlineFormType.WORK_ORDER&&scope.row.flowStatus !== '已办结'&&scope.row.flowStatus !== '已撤销'&&scope.row.flowStatus !== '暂存'"
                @click.stop="onHandlerRemindClick(scope.row)">
                催办
              </el-button>
              <el-button type="text" :size="defaultFormItemSize" class="table-btn error"
                v-if="formType === SysOnlineFormType.WORK_ORDER&&scope.row.flowStatus === '已办结' && $route.query.formId === '2074057865575796736' && getUserInfo.deptId  === '2039573101322178560'"
                @click.stop="handleStampClick(scope.row)">
                {{ scope.row.masterTable__seal ? '取消' : '盖章' }}
              </el-button>
              <!-- <el-button type="text" :size="defaultFormItemSize" class="table-btn error"
                v-if="formType === SysOnlineFormType.WORK_ORDER&&scope.row.flowStatus !== '已办结'&&scope.row.flowStatus !== '已撤销'"
                @click.stop="onCancelWorkOrder(scope.row)">
                撤销
              </el-button> -->
              <el-button type="text" :size="defaultFormItemSize" class="table-btn error"
                v-if="formType === SysOnlineFormType.WORK_ORDER&&scope.row.flowStatus !== '已办结'&&scope.row.flowStatus !== '已撤销' && $route.query.formId === '2074057865575796736'"
                @click.stop="handleRevoke(scope.row)">
                撤销
              </el-button>
              <el-button v-if="exportFlag" type="text" :size="defaultFormItemSize" class="table-btn"
                @click.stop="handleExport(scope.row)">
                导出
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!-- 分页组件 -->
      <el-col :span="24" v-if="widgetConfig.tableInfo.paged && !this.isNew"
        :style="{'margin-bottom': widgetConfig.supportBottom === 1 ? '20px' : undefined}"
      >
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="tableWidget.totalCount"
            :current-page="tableWidget.currentPage"
            :page-size="tableWidget.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="tableWidget.onCurrentPageChange"
            @size-change="tableWidget.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog title="撤回" :visible.sync="revokeDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="revokeForm" ref="revokeForm" label-width="100px">
        <el-form-item label="撤回原因" prop="comment" :rules="[{ required: true, message: '请输入撤回原因', trigger: 'blur' }]">
          <el-input v-model="revokeForm.comment" type="textarea" :rows="4" placeholder="请输入撤回原因" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="revokeDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="revokeLoading" @click="handleRevokeSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </el-col>
</template>

<script>
import { mapGetters } from 'vuex';
import { TableWidget } from '@/utils/widget.js';
import { uploadMixin } from '@/core/mixins';
import { getDictDataList, getDictDataByUrl } from '../utils/index.js';
import { Contract } from '@/api/contract';
import { Attendance } from '@/api/attendance'
import { FlowOperationController} from '@/api/flowController';

export default {
  props: {
    formType: {
      type: Number,
      required: true
    },
    widgetConfig: {
      type: Object,
      required: true
    },
    getTableQueryParams: {
      type: Function
    },
    loadTableDataFunc: {
      type: Function
    },
    flowData: {
      type: Object
    },
    // 是否是新建表格，如果为新建，增删改不会调用后台接口，直接把数据放到表格中
    isNew: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    },
    list:{
      type:Array,
      default:() => []
    }
  },
  inject: ['preview'],
  mixins: [uploadMixin],
  data () {
    return {
      // 表格用到的字典数据
      tableDictValueListMap: new Map(),
      tableWidget: new TableWidget(
        this.loadTableData,
        this.loadTableVerify,
        this.widgetConfig.tableInfo.paged && !this.isNew,
        false,
        this.widgetConfig.tableInfo.orderFieldName,
        this.widgetConfig.tableInfo.ascending
      ),
      selectRows: [],
      revokeDialogVisible: false,
      revokeLoading: false,
      revokeForm: { comment: '' },
      revokeRecord: {},
      flag:( this.widgetConfig.columnName === "oaFlowData180Detail" || this.widgetConfig.columnName === 'data164detail' ||  this.widgetConfig.columnName === 'oaFlowData160People' ||this.widgetConfig.columnName === 'oaFlowData162People') && !this.widgetConfig.readOnly,
      data:{},
      color:{ '处理中' : 'rgb(0, 128, 0)','审批中' : 'rgb(0, 128, 0)','已拒绝' : 'rgb(0, 128, 0)','已办结' : 'rgb(255, 0, 0)','已结束' : 'rgb(255, 0, 0)', '已撤销' : '#999','暂存':'#000'}, //任务状态color
      dictList:[],
      exportFlag: this.$route.query.formId === '1632945695503683584',
      isFirst: false
    }
  },
  watch:{
    tableWidget:{
      deep: true,
      immediate: true,
      handler(val){
        if(!val.dataList.length) {
         this.$emit('changeTotal', 0)
         return
        }
        let key = ''
        if(JSON.stringify(this.data) === "{}"){
          val.dataList = val.dataList.map(item => {
            for(var k in item){
              if(k.split('__').length === 2) {
               item[k.split('__')[1]] = item[k]
              }
            }
            return item
          })
          this.data = val.dataList[0]
        }

        for(var k in this.data ) {
          if(k.split('__')[1]) key = k.split('__')[0]
          if(key) break
        }
        if (val.dataList.length &&( key === 'oaFlowData162People' ||  key === 'oaFlowData160People' )&& this.isNew) {
          val.dataList.forEach((item,index) => {
            let data = {}
            for(var k in item){
              if(k.split('__').length < 2) {
               val.dataList[index][key + '__' + k] = item[k]
              }
            }
          })
        }
        let total_price = 0
        if (!key) key = this.widgetConfig?.variableName
        if(val.dataList.length && key === 'data164detail'){
            val.dataList.map(item => {
              const num = isNaN(item.data164detail__TOTAL * 1) ? 0 :  item.data164detail__TOTAL * 1
              total_price +=  num 
            })
        }
        if(val.dataList.length && key === 'oaFlowData180Detail'){
          val.dataList.map(item => {
            // const regex = /^\d*\.?\d+/g;
            // const matches = item.oaFlowData180Detail__amount.match(regex);
            // const num = matches ? matches[0]*1 :0
            const num = isNaN(item.oaFlowData180Detail__amount * 1) ? 0 :  item.oaFlowData180Detail__amount * 1
            total_price += num 
          })
        }
        this.$emit('update:list', val.dataList)
        this.$emit('changeTotal', total_price)
      }
    }
  },
  created () {
    setTimeout(() => {
      this.isFirst = true
    },2000)
    Attendance.gitDict(this, { dictId: '1638815451339296768' }).then(res => {
      this.dictList = res.data
    })
    
    if(localStorage.getItem(this.$route.query.processDefinitionKey + 'list')){
       this.tableWidget.dataList = JSON.parse(localStorage.getItem(this.$route.query.processDefinitionKey + 'list'))
    }
    const data = JSON.parse(localStorage.getItem(this.$route.query.formId))
    if (data && data.row && this.$route.query.formId === '1639182007915253760') {
        const row = data.row
        const reocrd = {
          flowWorkOrderDtoFilter: {doType: "3",serialNo: row.data_43},
          pageParam: {pageNum: 1, pageSize: 10},
        }
        FlowOperationController.listWorkOrder(this,reocrd,{processDefinitionKey:'all'}).then(rs => {
          if(rs.data.dataList.length === 0) {
            return
          }
          const row = rs.data.dataList[0]

          let params = {
            processInstanceId: row.processInstanceId
          }
          FlowOperationController.viewInitialHistoricTaskInfo(this, params).then(res => {
            if (res.data) {
              this.$router.push({
                name: res.data.routerName || 'handlerFlowTask',
                // 在线流程参数配置
                query: {
                  serialNo:row.serialNo,
                  isRuntime: false,
                  processDefinitionKey: row.processDefinitionKey,
                  processInstanceId: row.processInstanceId,
                  processDefinitionId: row.processDefinitionId,
                  formId: res.data.formId,
                  routerName: res.data.routerName,
                  readOnly: true,
                  flowEntryName: row.processDefinitionName,
                  processInstanceInitiator: row.processInstanceInitiator,
                  flag: false,
                  form: '1639182007915253760'
                }
              });
            }
        }).catch(e => {});
    
        })
    } else if(data) {
      this.$emit('operationClick', data.operation,data.row, {});
    }
  },
  methods: {
    // 盖章/取消盖章
    handleStampClick (row) {
      const isSealed = row.masterTable__seal
      const actionText = isSealed ? '取消盖章' : '盖章'
      this.$confirm(`确认要${actionText}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Contract.updateSeal(this, {
          data43: row.serialNo,
          seal: !isSealed
        }).then(res => {
          if (res.success) {
            this.$message.success(`${actionText}成功`)
            this.tableWidget.refreshTable()
          } else {
            this.$message.error(res.data?.msg || `${actionText}失败`)
          }
        }).catch(() => {})
      }).catch(() => {})
    },
    // 撤回
    handleRevoke (record) {
      this.revokeRecord = record
      this.revokeForm.comment = ''
      this.revokeDialogVisible = true
    },
    handleRevokeSubmit () {
      this.$refs.revokeForm.validate(valid => {
        if (!valid) return
        this.revokeLoading = true
        Contract.revokeToStart(this, {
          processInstanceId: this.revokeRecord.processInstanceId,
          comment: this.revokeForm.comment
        }).then(res => {
          this.revokeLoading = false
          if (res.success) {
            this.$message.success('撤回成功')
            this.revokeDialogVisible = false
            this.tableWidget.refreshTable();
          } else {
            this.$message.error(res.data.msg || '撤回失败')
          }
        }).catch(() => {
          this.revokeLoading = false
        })
      })
    },
    filterType (type) {
      if (type === 'long' || type==='int' || type === 'short' || type === 'byte' || type === 'float'|| type === 'double') {
        return 'number'
      } else {
        return 'text'
      }
    },
    // 付款审批单导出
    handleExport(row){
      let httpCall = this.download('/admin/upms/oaPayApproval/exportExcel/' + row.serialNo, {}, row.runName + '.xls');
      httpCall.then(res => {
        this.$message.success('导出成功！');
      }).catch(e => {
        this.$message.error(e);
      });
    },
    onTableSelectionChange (values,list) {
      this.selectRows = values;
    },
    onViewWorkOrder (row) {
      this.$emit('viewWOrkOrder', row, this.widgetConfig);
    },
    onHandlerWorkOrder (row) {
      this.$emit('handlerWOrkOrder', row, this.widgetConfig);
    },
    onHandlerRemindClick (row) {
      this.$emit('handlerRemind', row, this.widgetConfig);
    },
    // onCancelWorkOrder (row) {
    //   this.$emit('cancelWOrkOrder', row, this.widgetConfig);
    // },
    getTableWidget () {
      return this.tableWidget;
    },
    batchDelete () {
      if (!Array.isArray(this.selectRows) || this.selectRows.length <= 0) {
        this.$message.error('请选择要删除的数据！');
        return;
      }
      const data = JSON.parse(JSON.stringify(this.tableWidget))
      this.$confirm('是否删除选中数据？').then(res => {
        if (this.formType === this.SysOnlineFormType.FLOW) { // 工作流表单页面批量删除
          let selectIdList = this.selectRows.map(item => item.__cascade_add_id__);
          data.dataList = this.tableWidget.dataList.filter(item => {
            return selectIdList.indexOf(item.__cascade_add_id__) === -1;
          });
          this.tableWidget = {
            ...data
          }
        } else {
          let params = {
            datasourceId: this.widgetConfig.datasource.datasourceId,
            relationId: this.widgetConfig.relation ? this.widgetConfig.relation.relationId : undefined,
            dataIdList: this.selectRows.map(item => {
              return item[this.primaryColumnName];
            })
          }

          let httpCall;
          if (params.relationId) {
            httpCall = this.doUrl('/admin/online/onlineOperation/deleteBatchOneToManyRelation/' + this.widgetConfig.datasource.variableName, 'post', params);
          } else {
            httpCall = this.doUrl('/admin/online/onlineOperation/deleteBatchDatasource/' + this.widgetConfig.datasource.variableName, 'post', params);
          }
          httpCall.then(res => {
            this.tableWidget.refreshTable();
          }).catch(e => {
          });
        }
      }).catch(e => {});
    },
    setTableWidget (tableWidget) {
      // 如果正在读取数据，等待读取完毕再刷新
      let timer = setInterval(() => {
        if (!this.tableWidget.loading) {
          this.tableWidget.totalCount = tableWidget.totalCount;
          this.tableWidget.currentPage = tableWidget.currentPage;
          this.tableWidget.pageSize = tableWidget.pageSize;
          this.tableWidget.refreshTable();
          clearInterval(timer);
        }
      }, 30);
    },
    onOperationClick (operation, row) {
      operation.form = this.$route.query.formId
      if(operation.name === '编辑'){
        localStorage.setItem(this.$route.query.formId,JSON.stringify({
          operation, 
          row
        }))
      }
      if(this.$route.query.formId === '1639182007915253760'){
        const data = {
          flowWorkOrderDtoFilter: {doType: "3",serialNo: row.data_43},
          pageParam: {pageNum: 1, pageSize: 10},
        }
        FlowOperationController.listWorkOrder(this,data,{processDefinitionKey:'all'}).then(rs => {
          if(rs.data.dataList.length === 0) {
            return
          }
          const row = rs.data.dataList[0]
          let params = {
            processInstanceId: row.processInstanceId
          }
          FlowOperationController.viewInitialHistoricTaskInfo(this, params).then(res => {
            if (res.data) {
              this.$router.push({
                name: res.data.routerName || 'handlerFlowTask',
                // 在线流程参数配置
                query: {
                  serialNo:row.serialNo,
                  isRuntime: false,
                  processDefinitionKey: row.processDefinitionKey,
                  processInstanceId: row.processInstanceId,
                  processDefinitionId: row.processDefinitionId,
                  formId: res.data.formId,
                  routerName: res.data.routerName,
                  readOnly: true,
                  flowEntryName: row.processDefinitionName,
                  processInstanceInitiator: row.processInstanceInitiator,
                  flag: false,
                  form: '1639182007915253760'
                }
              });
            }
        }).catch(e => {});
    
        })
      } else {
      if (operation.btnType === 'primary' && operation.name ==='新建' && !row && this.flag) {
        let data = {
          __cascade_add_id__:this.tableWidget.dataList.length
        }
        this.widgetConfig.tableColumnList.forEach(item => {
          this.$set(data,item.dataFieldName,null)
        }) 
        this.data = data
        this.tableWidget.dataList.push({...data})
        return
      }
      if (operation.type === this.SysCustomWidgetOperationType.BATCH_DELETE) {
        this.batchDelete();
      } else if (operation.type === this.SysCustomWidgetOperationType.EXPORT) {
        this.export(operation);
      } else {
        this.$emit('operationClick', operation, row, this.widgetConfig);
      }

      }
    },
    export (operation) {
      this.$confirm('是否导出表格数据？').then(res => {
        if (this.formType === this.SysOnlineFormType.FLOW) {
          this.$message.error('工作流不支持导出！');
        } else {
          let queryParams = this.getTableQueryParams ? this.getTableQueryParams(this.widgetConfig) : undefined;
          console.log(1122333);
          
          let params = {
            datasourceId: this.widgetConfig.datasource.datasourceId,
            relationId: this.widgetConfig.relation ? this.widgetConfig.relation.relationId : undefined,
            filterDtoList: queryParams,
            exportInfoList: (operation.exportColumnList || []).sort((val1, val2) => {
              return val1.showOrder - val2.showOrder;
            })
          }
          let httpCall;
          if (params.relationId) {
            httpCall = this.download('/admin/online/onlineOperation/exportByOneToManyRelationId/' + this.widgetConfig.datasource.variableName, params, this.widgetConfig.showName + '.xls');
          } else {
            httpCall = this.download('/admin/online/onlineOperation/exportByDatasourceId/' + this.widgetConfig.datasource.variableName, params, this.widgetConfig.showName + '.xls');
          }
          httpCall.then(res => {
            this.$message.success('导出成功！');
          }).catch(e => {
            this.$message.error(e);
          });
        }
      }).catch(e => {});
    },
    loadTableDictValue (tableData) {
      return new Promise((resolve, reject) => {
        // URL字典数据获取列表
        let httpCallInfoList = [];
        let dictIdMap = new Map();
        this.widgetConfig.tableColumnList.forEach(tableColumn => {
          let column = tableColumn.column;
          // URL字典字典值数据分组
          if (column && column.dictInfo && column.dictInfo.dictType === this.SysOnlineDictType.URL) {
            let fieldName = tableColumn.dataFieldName;
            let urlDictIdInfo = dictIdMap.get(column.dictInfo.dictId);
            if (urlDictIdInfo == null) {
              let dictValueMap = this.tableDictValueListMap.get(column.dictInfo.dictId);
              urlDictIdInfo = {
                column,
                dictInfo: column.dictInfo,
                dictValueMap,
                paramSet: new Set()
              }
              httpCallInfoList.push(urlDictIdInfo);
              dictIdMap.set(column.dictInfo.dictId, urlDictIdInfo)
            }
            if (Array.isArray(tableData.dataList)) {
              tableData.dataList.forEach(row => {
                let value = row[fieldName];
                urlDictIdInfo.paramSet.add(value);
              });
            }
          }
        });
        Promise.all(httpCallInfoList.map(dictInfoItem => {
          if (dictInfoItem.dictInfo.dictIdsUrl == null || this.preview()) {
            if (!this.preview()) {
              this.$message.error('数据表字段 [' + dictInfoItem.column.columnName + '] 绑定字典 [' + dictInfoItem.dictInfo.dictName + '] 未发现获取指定ids数据url！');
            }
            resolve([]);
          } else {
            let dictIds = [];
            dictInfoItem.paramSet.forEach(item => {
              dictIds.push(item);
            });
            let params = {
              dictIds: dictIds
            }
            return getDictDataByUrl(dictInfoItem.dictInfo.dictIdsUrl, params, dictInfoItem.dictInfo, 'post');
          }
        })).then((dictValueDataList) => {
          dictValueDataList.forEach((dictDataList, index) => {
            dictDataList.forEach(data => {
              httpCallInfoList[index].dictValueMap.set(data.id, data);
            });
          });
          resolve(tableData);
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadTableData (params) {
      if (this.widgetConfig.datasource == null || this.isNew) {
        return Promise.resolve({
          dataList: this.tableWidget.dataList,
          totalCount: 0
        });
      }
      if (params == null) params = {};
      let queryParams = this.getTableQueryParams ? this.getTableQueryParams(this.widgetConfig) : undefined;
      params = {
        datasourceId: this.widgetConfig.datasource.datasourceId,
        relationId: this.widgetConfig.relation ? this.widgetConfig.relation.relationId : undefined,
        ...params,
        filterDtoList: queryParams
      }
      // this.$route.query.formId === '1639182007915253760' && 
      if(((params.pageParam.pageNum !== 1 ||  params.filterDtoList.length || this.isFirst) && !params.flowWorkOrderDtoFilter)){
        localStorage.setItem(this.$route.query.formId + 'search', JSON.stringify(params))
      }
      return new Promise((resolve, reject) => {
        if (typeof this.loadTableDataFunc === 'function') {
          return this.loadTableDataFunc(params).then(res => {
            // 获取表格字典数据
            return this.loadTableDictValue(res);
          }).then(res => {
            resolve(res);
          }).catch(e => {
            reject(e);
          });
        }
        let httpCall = null;
        if (params.relationId) {
          httpCall = this.doUrl('/admin/online/onlineOperation/listByOneToManyRelationId/' + this.widgetConfig.datasource.variableName, 'post', params);
        } else {
          httpCall = this.doUrl('/admin/online/onlineOperation/listByDatasourceId/' + this.widgetConfig.datasource.variableName, 'post', params);
        }
        httpCall.then(res => {
          // 获取表格字典数据
          return this.loadTableDictValue(res.data);
        }).then(res => {
          resolve({
            dataList: res.dataList,
            totalCount: res.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadTableVerify () {
      return true;
    },
    // 页面是否是返回状态
    isResume () {
      let key = this.$route.fullPath;
      let cacheFormData = this.getOnlineFormCache[key];
      return cacheFormData != null;
    },
    /**
     * 刷新表格数据
     * row：表格数据，如果表格数据为空，则重新获取
     * operatorType：表格数据操作类型
     */
    refresh (row, operatorType) {
      if (this.isResume()) return;
      if (!this.isNew) {
          // 重新获取表格数据
          this.tableWidget.refreshTable(false,1);
      } else {
        if (operatorType === this.SysCustomWidgetOperationType.ADD) this.tableWidget.dataList.push(row);
        if (operatorType === this.SysCustomWidgetOperationType.EDIT) {
          this.tableWidget.dataList = this.tableWidget.dataList.map(item => {
            if (item.__cascade_add_id__ == null ? item[this.primaryColumnName] === row[this.primaryColumnName] : item.__cascade_add_id__ === row.__cascade_add_id__) {
              return {
                ...row
              }
            } else {
              return item;
            }
          });
        }
        if (operatorType === this.SysCustomWidgetOperationType.DELETE) {
          this.tableWidget.dataList = this.tableWidget.dataList.filter(item => {
            return item !== row;
          });
        }
      }
    },
    onCurrentPageChange(page){
      this.tableWidget.onCurrentPageChange(page);
    },
    getTableOperation (rowOperation) {
      if (this.widgetConfig.readOnly) return [];
      let tempList = this.widgetConfig.operationList.filter(operation => {
        return operation.rowOperation === rowOperation && operation.enabled;
      });
      // 自定义操作前置
      if (rowOperation) {
        let customOperation = [];
        return customOperation.concat(tempList.filter(item => {
          if (item.type === this.SysCustomWidgetOperationType.CUSTOM) customOperation.push(item);
          return item.type !== this.SysCustomWidgetOperationType.CUSTOM;
        }));
      }
      return tempList;
    },
    /**
     * 获取表格列字段在后端返回的接口中字段名
     */
    getTableColumnFieldName (tableColumn) {
      if (tableColumn.column == null) return null;
      let fieldName = tableColumn.column.columnName || tableColumn.column.objectFieldName;
      if (tableColumn.relation != null) {
        fieldName = tableColumn.relation.variableName + '__' + fieldName;
      }
      // 工单列表
      if (this.formType === this.SysOnlineFormType.WORK_ORDER) {
        fieldName = 'masterTable__' + fieldName;
      }
      return fieldName;
    },
    /**
     * 获取表格cell数据字典值
     */
    getDictValue (tableColumn, row) {
      let dictData = null;
      let value = row[tableColumn.dataFieldName];
      // 如果有DictMap信息，优先使用DictMap信息
      if (tableColumn.column.dictInfo != null) {
        if (row[tableColumn.dataFieldName + '__DictMap']) {
          return row[tableColumn.dataFieldName + '__DictMap'].name;
        }
      }
      let dictValueList = this.tableDictValueListMap.get(tableColumn.column.dictInfo.dictId);
      if (dictValueList != null) {
        dictData = dictValueList.get(value);
      }

      return dictData ? dictData.name : undefined;
    },
    getDict(tableColumn, index){
      if (tableColumn.column.dictInfo.keyColumnName) {
        return this.dictList
      }else{
        return JSON.parse(tableColumn.column.dictInfo.dictDataJson).dictData
      }
    },
    getDownloadUrl (tableColumn) {
      let downloadUrl = null;
      if (this.flowData != null) {
        downloadUrl = '/admin/flow/flowOnlineOperation/download';
      } else {
        if (tableColumn.relationId) {
          downloadUrl = '/admin/online/onlineOperation/downloadOneToManyRelation/' + (this.widgetConfig.datasource || {}).variableName;
        } else {
          downloadUrl = '/admin/online/onlineOperation/downloadDatasource/' + (this.widgetConfig.datasource || {}).variableName;
        }
      }

      return downloadUrl;
    },
    parseTableUploadData (tableColumn, row) {
      let jsonData = row[tableColumn.dataFieldName];
      if (jsonData == null) return [];
      let downloadParams = {
        ...this.buildFlowParam,
        datasourceId: this.widgetConfig.datasource.datasourceId,
        relationId: tableColumn.relationId,
        fieldName: tableColumn.column.columnName,
        asImage: tableColumn.column.fieldKind === this.SysOnlineFieldKind.UPLOAD_IMAGE
      }

      if (this.primaryColumnName != null) {
        downloadParams.dataId = row[this.primaryColumnName] || '';
      }

      let downloadUrl = this.getDownloadUrl(tableColumn);

      let temp = JSON.parse(jsonData).map(item => {
        return {
          ...item,
          downloadUri: downloadUrl
        }
      })
      return this.parseUploadData(JSON.stringify(temp), downloadParams);
    },
    getTablePictureList (tableColumn, row) {
      let temp = this.parseTableUploadData(tableColumn, row);
      if (Array.isArray(temp)) {
        return temp.map(item => item.url);
      }
    }
  },
  mounted () {
    if (Array.isArray(this.widgetConfig.tableColumnList)) {
      // 字典数据获取信息，包含静态字典和自定义字典信息
      let httpCallInfoList = [];
      this.widgetConfig.tableColumnList.forEach(tableColumn => {
        tableColumn.dataFieldName = this.getTableColumnFieldName(tableColumn);
        let column = tableColumn.column;
        if (column && column.dictInfo && column.dictInfo.dictType !== this.SysOnlineDictType.TABLE) {
          if (!this.tableDictValueListMap.has(column.dictInfo.dictId)) {
            let tempMap = new Map();
            this.tableDictValueListMap.set(column.dictInfo.dictId, tempMap);
            if (column.dictInfo.dictType !== this.SysOnlineDictType.URL) {
              httpCallInfoList.push({
                valueMap: tempMap,
                httpCall: getDictDataList(this, column.dictInfo)
              });
            }
          }
        }
      });
      // 获取所有静态字典和自定义字典数据
      Promise.all(httpCallInfoList.map(item => item.httpCall)).then(dictValueList => {
        dictValueList.forEach((dictDataList, index) => {
          if (Array.isArray(dictDataList)) {
            dictDataList.forEach(data => {
              httpCallInfoList[index].valueMap.set(data.id, data);
            });
          }
        });
        this.refresh();
      }).catch(e => {
        this.$message.error('获取表格字典数据失败！');
      });
    } else {
      this.refresh();
    }
  },
  computed: {
    hasBatchDelete () {
      for (let i = 0; i < this.widgetConfig.operationList.length; i++) {
        if (this.widgetConfig.operationList[i].type === this.SysCustomWidgetOperationType.BATCH_DELETE && this.widgetConfig.operationList[i].enabled) {
          return true;
        }
      }
      return false;
    },
    buildFlowParam () {
      let flowParam = {};
      if (this.flowData) {
        if (this.flowData.processDefinitionKey) flowParam.processDefinitionKey = this.flowData.processDefinitionKey;
        if (this.flowData.processInstanceId) flowParam.processInstanceId = this.flowData.processInstanceId;
        if (this.flowData.taskId) flowParam.taskId = this.flowData.taskId;
      }

      return flowParam;
    },
    primaryColumnName () {
      if (this.widgetConfig && this.widgetConfig.table && Array.isArray(this.widgetConfig.table.columnList)) {
        for (let i = 0; i < this.widgetConfig.table.columnList.length; i++) {
          let column = this.widgetConfig.table.columnList[i];
          if (column.primaryKey) {
            return (this.widgetConfig.relation ? this.widgetConfig.relation.variableName + '__' : '') + column.columnName;
          }
        }
      }
      return null;
    },
    ...mapGetters(['getOnlineFormCache']),
    ...mapGetters(['getUserInfo'])
  }
}
</script>

<style scoped>
  .table-title {
    padding: 0px 5px;
    height: 22px;
    line-height: 22px;
    margin: 3px 0px;
    font-size: 16px;
    font-weight: 700;
  }
</style>
